import { useQuery } from "@apollo/client";

import { GET_CURRENT_OFFER_SUMMARY, GET_CURRENT_OFFER_SUMMARY_FED } from "api/queries";
import { offerMapper } from "helpers/offerMapper";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useEffect, useState } from "react";

export default function useGetEmptyInfoForOffer (loadNumber: number, id: number, skip: boolean) {
  const { useGQLFederation } = useFlags();
  const [offerInfo, setOfferInfo] = useState<any>({});
  const query = useGQLFederation ? GET_CURRENT_OFFER_SUMMARY_FED : GET_CURRENT_OFFER_SUMMARY;
  const variables = useGQLFederation ? {
    "arguments": {
      "loadIds": loadNumber
    },
    "where": {
      "id": {
        "eq": id
      }
    }
  } : {
    loadNumber: loadNumber,
    id: id
  }
  const { data, loading: loadingOfferInfo } = useQuery(query, {
    variables: variables,
    skip: skip,
    fetchPolicy: 'network-only',
    context: { isFederated: useGQLFederation }
  })

  const adapter = (_data: any) => {
    if(useGQLFederation) {
      return offerMapper(_data?.offers?.nodes[0]);
    }

    return data?.getOfferSummary || {}
  }

  useEffect(()=> {
    setOfferInfo(adapter(data))
  }, [data]) //eslint-disable-line

  return {offerInfo, loadingOfferInfo}
}
